var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchReservedInstanceReporting32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Reserved-Instance-Reporting_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B660F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CAE3E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Reserved-Instance-Reporting_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/AWS-Cost-Management",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.379,27.672 L24.854,24.147 L24.147,24.854 L27.67,28.378 L20.503,31.349 L13.328,28.379 L16.854,24.854 L16.147,24.147 L12.623,27.671 L9.651,20.503 L12.621,13.328 L16.147,16.854 L16.854,16.147 L13.33,12.623 L20.497,9.651 L27.672,12.621 L24.147,16.147 L24.854,16.854 L28.377,13.33 L31.349,20.497 L28.379,27.672 Z M34,21 L34,20 L32.225,20 L29.143,12.564 L30.854,10.854 L30.147,10.147 L28.438,11.856 L21,8.777 L21,7 L20,7 L20,8.776 L12.565,11.857 L10.854,10.147 L10.147,10.854 L11.856,12.563 L8.777,20 L7,20 L7,21 L8.775,21 L11.858,28.436 L10.147,30.147 L10.854,30.854 L12.563,29.145 L20,32.223 L20,34 L21,34 L21,32.225 L28.436,29.143 L30.147,30.854 L30.854,30.147 L29.145,28.438 L32.223,21 L34,21 Z M20.5,23.24 C18.989,23.24 17.76,22.011 17.76,20.5 C17.76,18.989 18.989,17.76 20.5,17.76 C22.011,17.76 23.24,18.989 23.24,20.5 C23.24,22.011 22.011,23.24 20.5,23.24 L20.5,23.24 Z M20.5,16.76 C18.438,16.76 16.76,18.438 16.76,20.5 C16.76,22.563 18.438,24.24 20.5,24.24 C22.563,24.24 24.24,22.563 24.24,20.5 C24.24,18.438 22.563,16.76 20.5,16.76 L20.5,16.76 Z",
    id: "Reserved-Instance-Reporting_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchReservedInstanceReporting32);
export default __webpack_public_path__ + "static/media/Arch_Reserved-Instance-Reporting_32.e6c1b42eaac281fb27e1e810e8239786.svg";
export { ForwardRef as ReactComponent };